import React, { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
// Removed Environment and useEnvironment to fix "Failed to fetch venice_sunset_1k.hdr" error
import HammerSlam3D from './HammerSlam2D'

export interface Effect3D {
    id: string
    type: 'hammerSlam'
    sx: number
    sy: number
    tx: number
    ty: number
    isTargetPerspective?: boolean
}

interface ThreeEffectsOverlayProps {
    effects: Effect3D[]
    onComplete: (id: string) => void
}

const ThreeEffectsOverlay: React.FC<ThreeEffectsOverlayProps> = ({ effects, onComplete }) => {
    if (effects.length === 0) return null

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 9999,
                pointerEvents: 'none', // Ensure clicks pass through
            }}
        >
            <Canvas
                camera={{ position: [0, 40, 25], fov: 35, near: 0.1, far: 1000 }} // Hearthstone-like isometric angle
                gl={{ alpha: true, antialias: true, powerPreference: 'high-performance' }}
                style={{ background: 'transparent', pointerEvents: 'none' }}
            >
                {/* Environment map removed to prevent crash on missing HDR */}
                {/* <Environment preset="sunset" /> */}

                {/* Omnidirectional lighting - all sides */}
                <ambientLight intensity={2.0} />

                {/* Top light */}
                <directionalLight position={[0, 50, 0]} intensity={3} color="#ffffff" />

                {/* Front light */}
                <directionalLight position={[0, 20, 30]} intensity={2} color="#ffffff" />

                {/* Back light */}
                <directionalLight position={[0, 20, -30]} intensity={1.5} color="#aaddff" />

                {/* Left light */}
                <directionalLight position={[-30, 20, 0]} intensity={1.5} color="#ffddaa" />

                {/* Right light */}
                <directionalLight position={[30, 20, 0]} intensity={1.5} color="#ffddaa" />

                {/* Bottom fill light */}
                <directionalLight position={[0, -10, 0]} intensity={0.8} color="#aaccff" />

                {/* Point lights for extra brightness */}
                <pointLight position={[0, 40, 0]} intensity={3} color="#ffffff" distance={100} />
                <pointLight position={[0, 20, 20]} intensity={2} color="#ffeecc" distance={80} />

                <Suspense fallback={null}>
                    {effects.map(eff => {
                        if (eff.type === 'hammerSlam') {
                            return (
                                <HammerSlam3D
                                    key={eff.id}
                                    sourceX={eff.sx}
                                    sourceY={eff.sy}
                                    targetX={eff.tx}
                                    targetY={eff.ty}
                                    onComplete={() => onComplete(eff.id)}
                                    isTargetPerspective={eff.isTargetPerspective}
                                />
                            )
                        }
                        return null
                    })}
                </Suspense>
            </Canvas>
        </div>
    )
}

export default ThreeEffectsOverlay
